import {
  LocationResponseDto,
  ProductCreateRequestDto,
} from '@tiendanube/common';
import { ProductCreateRequestApiV2Dto } from '@tiendanube/common/src/domains/catalog/interfaces';
import { LanguagesType } from 'App/i18n';
import { getCreateVariantsPayload } from './getCreateVariantsPayload';
import {
  getCategories,
  getImages,
  getMedia,
  getMetafields,
  getSections,
  getTags,
} from './helpers';
import { getAttributes, getI18nResponseDto } from '../shared/helpers';

export function getCreateProductPayload(
  product: ProductCreateRequestDto,
  language: LanguagesType,
  locations: LocationResponseDto[],
): ProductCreateRequestApiV2Dto {
  const {
    name,
    categories,
    description,
    handle,
    published,
    attributes,
    variants,
    images,
    brand,
    free_shipping,
    requires_shipping,
    tags,
    seo_title,
    seo_description,
    video_url,
    productMetafields,
    sectionCodes,
    media,
  } = product;

  return {
    name: getI18nResponseDto(name, language),
    description: description
      ? getI18nResponseDto(description, language)
      : { default: '' },
    publish: published,
    variants: getCreateVariantsPayload(language, variants, locations),
    ...(handle ? { handle: { ...handle, default: handle[language] } } : {}),
    brand: brand,
    free_shipping: free_shipping,
    requires_shipping: requires_shipping,
    ...(seo_title
      ? { seo_title: getI18nResponseDto(seo_title, language) }
      : {}),
    ...(seo_description
      ? { seo_description: getI18nResponseDto(seo_description, language) }
      : {}),
    video_url: video_url,
    sections: getSections(sectionCodes),
    ...(getTags(tags) ?? {}),
    ...(getAttributes(language, attributes) ?? {}),
    ...(getImages(images) ?? {}),
    ...(getCategories(categories) ?? {}),
    ...(getMetafields(productMetafields) ?? {}),
    ...(getMedia(media) ?? {}),
  };
}
